import React from 'react';
import { Card, Col, Row, Statistic, Button, Typography, Space } from 'antd';
import {
  ShoppingOutlined,
  ThunderboltOutlined,
  PictureOutlined,
  VideoCameraOutlined,
  ArrowRightOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './index.css';

const { Title, Paragraph, Text } = Typography;

function App() {
  const navigate = useNavigate();
  const nickname = localStorage.getItem('nickname') || localStorage.getItem('username') || '用户';

  return (
    <div className="page-shell">
      <div className="page-hero dashboard-hero">
        <div>
          <Text className="page-kicker">工作台</Text>
          <Title level={2}>欢迎回来，{nickname}</Title>
          <Paragraph>
            从商品素材入库到动作视频生成，常用工作流都在这里集中处理。
          </Paragraph>
        </div>
        <Space wrap>
          <Button type="primary" icon={<ShoppingOutlined />} onClick={() => navigate('/product')}>
            添加商品
          </Button>
          <Button icon={<ThunderboltOutlined />} onClick={() => navigate('/gen2')}>
            生成视频
          </Button>
        </Space>
      </div>

      <Row gutter={[16, 16]} className="metric-row">
        <Col xs={24} sm={12} lg={6}>
          <Card className="metric-card">
            <Statistic title="商品素材" value="商品管理" prefix={<ShoppingOutlined />} />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card className="metric-card">
            <Statistic title="形象资源" value="形象库" prefix={<PictureOutlined />} />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card className="metric-card">
            <Statistic title="动作素材" value="视频库" prefix={<VideoCameraOutlined />} />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card className="metric-card">
            <Statistic title="生成流程" value="一站式" prefix={<ThunderboltOutlined />} />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card
            className="action-card"
            title="商品管理"
            extra={<Button type="link" icon={<ArrowRightOutlined />} onClick={() => navigate('/product')}>进入</Button>}
          >
            <Paragraph>
              维护商品链接、主图、封面图和发布状态，快速跳转到对应商品的视频生成流程。
            </Paragraph>
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card
            className="action-card"
            title="动作视频"
            extra={<Button type="link" icon={<ArrowRightOutlined />} onClick={() => navigate('/gen2')}>进入</Button>}
          >
            <Paragraph>
              选择人物形象、服装图片和动作参考视频，生成用于短视频内容的动作模仿成片。
            </Paragraph>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default App;